function moneyFormatHandler(money) {
  return `${moneySymbol}${(money / 100).toFixed(2)}`;
}

var inputQtyValue = 1;
var wasChanged = false;

document.body.addEventListener('click', (e) => {
  const qtyInput = document.querySelector('.product__quantity .js-qty__wrapper .js-qty__num');
  const valuePackItem = e.target.closest('.value__pack-item');
  if (valuePackItem) {
    const oldSelected = document.querySelector('.value__pack-item.selected');
    oldSelected && oldSelected.classList.remove('selected');
    !valuePackItem.classList.contains('disabled') && valuePackItem.classList.add('selected');

    if (!wasChanged) {
      inputQtyValue = valuePackItem.dataset.qty;
    }

    if (qtyInput) {
      qtyInput.value = inputQtyValue;
    }

    if (!wasChanged && window.checkThresholdGlobal) {
      window.checkThresholdGlobal(true);
    }

    wasChanged = false;

    window.valuePackButtonHandler();
  }
})

window.valuePackInventoryHandler = (currentVal) => {
  const qtyInput = document.querySelector('.product__quantity .js-qty__wrapper .js-qty__num');
  const valuePackItems = document.querySelectorAll('.value__pack-item');

  if (!qtyInput || valuePackItems.length === 0) {
    return;
  }

  const targetQty = parseInt(qtyInput.value, 10);
  let closestItem = null;
  let smallestDiff = Infinity;

  valuePackItems.forEach(item => {
    const itemQty = parseInt(item.dataset.qty, 10);
    const diff = Math.abs(itemQty - targetQty);
    if (diff < smallestDiff) {
      smallestDiff = diff;
      closestItem = item;
    }
  });

  if (closestItem) {
    if (currentVal) {
      inputQtyValue = currentVal;
      wasChanged = true;
    }
    closestItem.click();
  }

  window.valuePackButtonHandler();
}

window.valuePackButtonHandler = () => {
  const qtyInput = document.querySelector('.product__quantity .js-qty__wrapper .js-qty__num');
  const selectedItem = document.querySelector('.value__pack-item.selected');
  const currentPriceElement = document.querySelector('.product-single__form.product-form-default button.add-to-cart span.value-packs-price');
  const submitButton = document.querySelector('.product-single__form.product-form-default button.add-to-cart');
  const valuePacksWrapper = document.querySelector('.product-block.product-block-value-packs');
  currentPriceElement && currentPriceElement.remove();

  if (selectedItem && !valuePacksWrapper.getAttribute('style')?.includes('display: none;')) {
    const selecteItemPrice = selectedItem.querySelector('.price').dataset.price;
    const price = selecteItemPrice * qtyInput.value;

    const newPriceElement = document.createElement('span');
    newPriceElement.innerText = moneyFormatHandler(price);
    newPriceElement.classList.add('value-packs-price');
    submitButton.appendChild(newPriceElement);
  }
}